import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.NewRequestPopup.PayAndCapturePromotion', {
    payHeader: 'Pay approved bills directly from ApprovalMax',
    captureHeader: 'Extract data from images and PDFs in seconds with ApprovalMax Capture — no manual entry needed.',
    tryNowPayButtonText: 'Try now',
    tryNowCaptureButtonText: 'Start automating',
    captureDescription: '100 free documents',
});
